// extracted by mini-css-extract-plugin
export default {"result-pill-container":"styles__result-pill-container--oqejS","input-container":"styles__input-container--BtmvA","list-label":"styles__list-label--zcpD2"};